import { Location, NgClass } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CardComponent } from '@sportello-balneari/shared-components';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { CompiledSectionComponent } from '../../components/tile/compiled/section/section.component';
import { CompiledService } from '../../services/compiled/compiled.service';
import { CompilingFormService } from '../../services/compiling/compiling-form.service';
import { CompilingDashboardService } from '../new-compiling-dashboard/compiling-dashboard.service';
@Component({
  selector: 'lib-compiled-dashboard',
  templateUrl: './compiled-dashboard.component.html',
  styleUrls: ['./compiled-dashboard.component.css'],
  imports: [
    MatIconModule,
    PaginatorModule,
    CompiledSectionComponent,
    NgClass,
    CardComponent,
  ],
  providers: [CompiledService, CompilingDashboardService],
  styles: [
    `
      :host {
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
      }
    `,
  ],
})
export class CompiledDashboardComponent {
  private location = inject(Location);
  private compilingDashboardService = inject(CompilingDashboardService);
  protected moduleCompiledService = inject(CompiledService);
  protected forms = inject(CompilingFormService);

  sectionId = computed(() => {
    const start = this.first();
    const module = this.forms.moduleStructure();

    if (!module) return undefined;

    return module.root.children[start];
  });

  first = signal<number>(0);

  constructor() {
    effect(() => {
      const ready = this.forms.ready();
      if (ready) {
        this.forms.form.disable();
      }
    });
  }

  onPageChange(event: PaginatorState) {
    this.first.set(event.first ?? 0);
  }

  exit() {
    this.location.back();
  }

  loadAndFocus(sectionIndex: number, subsectionId: string) {
    this.first.set(sectionIndex);
    this.compilingDashboardService.subSectionToFocus.set(subsectionId);
  }
}
